import { z } from 'zod';
import { paginatedResponse } from './common';

/**
 * Schemas for the read-only /audit-logs admin endpoint.
 * The write side (AuditLog rows) is produced by feature services directly.
 */

export const auditLogActor = z
  .object({
    id: z.string(),
    email: z.string().email(),
  })
  .nullable();
export type AuditLogActor = z.infer<typeof auditLogActor>;

export const auditLogItem = z.object({
  id: z.string(),
  actorId: z.string().nullable(),
  actor: auditLogActor,
  action: z.string(),
  resourceType: z.string(),
  resourceId: z.string().nullable(),
  metadata: z.unknown().nullable(),
  ip: z.string().nullable(),
  userAgent: z.string().nullable(),
  createdAt: z.string().datetime({ offset: true }),
});
export type AuditLogItem = z.infer<typeof auditLogItem>;

export const listAuditLogsQuery = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(200).default(50),
  actorId: z.string().trim().min(1).max(64).optional(),
  actorEmail: z.string().trim().min(1).max(254).optional(),
  action: z.string().trim().min(1).max(120).optional(),
  resource: z.string().trim().min(1).max(120).optional(),
  from: z.string().datetime({ offset: true }).optional(),
  to: z.string().datetime({ offset: true }).optional(),
});
export type ListAuditLogsQuery = z.infer<typeof listAuditLogsQuery>;

export const listAuditLogsResponse = paginatedResponse(auditLogItem);
export type ListAuditLogsResponse = z.infer<typeof listAuditLogsResponse>;
